































import Vue from 'vue';
import ReportTable, { SortSpec } from '@/components/ReportTable.vue';
import ReportControls, { ReportSpecByWeek, Account } from '@/components/ReportControls.vue';
import axios from 'axios';
import XLSX from 'xlsx';
import moment from 'moment';

function format(value: number, row: Array<string | number>) {
  const total = row.slice(3, 9).reduce((acc: number, x) => typeof x === 'number' ? acc + x : acc, 0);
  const percent = value / total * 100;
  return `${value} (${percent.toFixed(1)}%)`;
}

export default Vue.extend({
  name: 'HubProductMix',
  components: {ReportControls, ReportTable},
  data() {
    return {
      loading: true,
      spec: {} as ReportSpecByWeek,
      hubHeaders: [] as string[],
      hubData: [],
      productHeaders: [],
      productData: [],
      yearToDate: [],
      hubBreakdowns: {},
      productBreakdowns: {},
      columnConfig: [
        {},
        {},
        {},
        {format},
        {format},
        {format},
        {format},
        {format},
        {format},
      ],
    };
  },
  computed: {
    dataUrl(): string {
      const {depot, from, to} = this.spec;
      return this.buildDataUrl(depot, from, to);
    },
    hubExtraColumns() {
      function sum(xs: number[]) {
        return xs.reduce((a, b) => a + b, 0);
      }

      const nonNetwork = this.hubHeaders.slice(1).findIndex(
          (h) => !h.includes('General') && !h.includes('Groupage'));
      return {
        'Network': (row: number[]) => sum(row.slice(nonNetwork)),
        'Non Network %': (row: number[]) => {
          const fraction = sum(row.slice(0, nonNetwork)) / sum(row);
          return `${(fraction * 100).toFixed(1)}%`;
        },
        'Network %': (row: number[]) => {
          const total = sum(row);
          const fraction = (total - sum(row.slice(0, nonNetwork))) / total;
          return `${(fraction * 100).toFixed(1)}%`;
        },
      };
    },
  },
  watch: {
    async spec() {
      this.loading = true;
      const response = await axios.get(this.dataUrl, {
        params: {
          account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
        },
      });
      this.hubHeaders = response.data.hub_headers;
      this.hubData = response.data.hub_results;
      this.productHeaders = response.data.product_headers;
      this.productData = response.data.product_results;
      // this.yearToDate = response.data.results.yearToDate;
      this.loading = false;
    },
  },
  methods: {
    download() {
      const wb = XLSX.utils.book_new();
      const hubByWeekSheet = XLSX.utils.table_to_sheet((this.$refs.hubByWeek as Vue).$el);
      for (const cellRef of Object.getOwnPropertyNames(hubByWeekSheet)) {
        const cell = hubByWeekSheet[cellRef];
        if (cellRef.startsWith('A')) {
          cell.t = 's';
        } else if (cellRef.startsWith('J') || cellRef.startsWith('K')) {
          cell.z = '0.00%';
        }
      }
      const productByWeekSheet = XLSX.utils.table_to_sheet((this.$refs.productByWeek as Vue).$el);
      XLSX.utils.book_append_sheet(wb, hubByWeekSheet, 'Hub by Week YTD');
      XLSX.utils.book_append_sheet(wb, productByWeekSheet, 'Product by Week YTD');
      const {depot, from, to} = this.spec;
      XLSX.writeFile(wb, 'Hub and Product Mix for Depot'
          + `${depot} - ${from.year}${to.week} to ${to.year}${to.week}.xlsx`);
    },
    buildDataUrl(depot: string, from: { year: number, week: number }, to: { year: number, week: number }): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      return `${BASE_URL}/reports/hub-product-mix/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
    },
    async breakdown({key, sort}: { key: string, sort: SortSpec }) {
      if (key in this.hubBreakdowns) {
        this.$delete(this.hubBreakdowns, key);
        this.$delete(this.productBreakdowns, key);
        return;
      }
      const yearWeek = {
        year: 2000 + parseInt(key.slice(2, 4), 10),
        week: parseInt(key.slice(5, 7), 10),
      };
      const url = this.buildDataUrl(this.spec.depot, yearWeek, yearWeek);
      const response = await axios.get(url, {
        params: {
          account_codes: this.spec.accountCodes.flatMap((a) => a.codes),
          daily: true,
        },
      });
      const hubDays = response.data.hub_results;
      const productDays = response.data.product_results;
      if (sort) {
        const cmpData = (a: Array<number | string>, b: Array<number | string>) => {
          if (typeof (a[sort.index]) === 'string') {
            const aStr = a[sort.index] as string;
            const bStr = b[sort.index] as string;
            if (sort.direction === 'DESC') {
              return bStr.localeCompare(aStr);
            } else {
              return aStr.localeCompare(bStr);
            }
          } else {
            const aNum = a[sort.index] as number;
            const bNum = b[sort.index] as number;
            if (sort.direction === 'DESC') {
              return bNum - aNum;
            } else {
              return aNum - bNum;
            }
          }
        };
        hubDays.sort(cmpData);
        productDays.sort(cmpData);
      }
      this.$set(this.hubBreakdowns, key, hubDays.map((r: Array<string | number>) => {
        return [
          moment(r[0]).format('ddd DD MMM'),
          ...r.slice(1),
        ];
      }));
      this.$set(this.productBreakdowns, key, productDays.map((r: Array<string | number>) => {
        return [
          moment(r[0]).format('ddd DD MMM'),
          ...r.slice(1),
        ];
      }));
    },
  },
});
